import api from '../services'
import AuthService from '../services/auth.service'

export default {
	namespaced: true,
	state: {
		isAuth: localStorage.getItem('x-backend-auth') || false,
		permissions: {},
		features: {},
		prefix: null,
	},
	getters: {
		hasPermission: (state) => (perm) => {
			return (
				state.permissions.hasOwnProperty('@admin') ||
				(state.permissions.hasOwnProperty(perm) && state.permissions[perm])
			)
		},
		hasFeature: (state) => (feature) => {
			return state.features.hasOwnProperty(feature) && state.features[feature]
		},
		truewalletVoucher:(state) => {
			return state.prefix?.truewalletVoucher
		}
	},
	actions: {
		async fetchAuthInfo({ commit }) {
			try {
				const res = await api.get('/auth')

				commit('FETCH_AUTH_INFO', res)
				return res
			} catch (e) {
				return Promise.reject(e)
			}
		},
		getPermissions({ commit }) {
			return AuthService.getPermissions()
				.then((res) => {
					commit('FETCH_PERMISSION_SUCCESS', res)
					return Promise.resolve(res)
				})
				.catch((err) => {
					return Promise.reject(err)
				})
		},
		getFeatures({ commit }) {
			return AuthService.getFeatures()
				.then((res) => {
					commit('FETCH_FEATURE_SUCCESS', res)
					return Promise.resolve(res)
				})
				.catch((err) => {
					return Promise.reject(err)
				})
		},
	},
	mutations: {
		FETCH_AUTH_INFO(state, payload) {
			state.permissions = payload.permissions
			state.features = payload.features
			state.prefix = payload.prefix
		},
		FETCH_PERMISSION_SUCCESS(state, payload) {
			state.permissions = payload
		},
		FETCH_FEATURE_SUCCESS(state, payload) {
			state.features = payload
		},
	},
}
